$bog_blitz $mol_page
	title @ \Blitz Quiz
	pages *
		lobby <= Lobby $bog_blitz_lobby
		admin <= Admin $bog_blitz_admin
		profile <= Profile $bog_blitz_profile_page
		- feedback <= Feedback $bog_feedback2_form
			feedback_id \blitz
	nav_options *
		lobby \Лобби
		admin \Админ
		profile \Профиль
	Navbar $mol_switch
		value? <=> screen? \lobby
		options <= nav_options
	Mobile_nav $mol_switch
		value? <=> screen? \lobby
		options <= nav_options
	Mobile_menu $mol_pop
		showed? <=> mobile_menu_showed? false
		Anchor <= Mobile_menu_trigger $mol_check
			checked? <=> mobile_menu_showed? false
			sub /
				<= Mobile_menu_icon $mol_icon_menu
		bubble_content /
			<= Mobile_nav 
	tools /
		- <= Feedback_link $mol_link
			arg *
				screen \feedback
			sub /
				<= Feedback_icon $mol_icon_message_draw
		<= Settings $mol_pick
			hint \Настройки
			trigger_content /
				<= Settings_icon $mol_icon_cog
			bubble_content /
				<= Settings_content $mol_row sub /
					<= Status $giper_baza_status
					<= Theme_toggle $bog_theme_toggle theme_auto <= Theme
					<= Sources $mol_link_source uri \https://github.com/b-on-g/blitz
				<= Powered $mol_text text \
					\Пишите нам в [Telegram](https://t.me/@Dev_Cmyser)
					\*Создано на [$mol](https://mol.hyoo.ru/#!section=docs/=4kd8nv_evh111) и [Giper Baza](https://t.me/mol_news/226)*
		<= Radio $bog_blitz_radio
	head /
		<= Title
		<= Navbar
		<= Tools
		<= Mobile_menu
	plugins /
		- <= Metrics $bog_metrics
			app \blitz
		<= Theme $bog_theme_auto
			theme_light \$mol_theme_calm_light
			theme_dark \$mol_theme_calm_dark
			themes /
				\$mol_theme_calm_light
				\$mol_theme_calm_dark
	body <= screen_body /
